import React from "react";
import {
  BPJS_DAFTAR_TAGIHAN,
  BPJS_VCLAIM_REFENSI,
  BPJS_VCLAIM_PENGAJUAN,
  BPJS_VCLAIM_UPDATE_TGL_PLG,
  BPJS_WSBPJS_REFERENSI,
  INPUT_EKLAIM,
  PURIFIKASI,
  REKONSILIASI,
  REKONSILIASI_BPJS,
  UPLOAD_MANUAL,
  BPJS_VCLAIM_RUJUKAN,
  BPJS_VCLAIM_PRB,
  BPJS_WSBPJS_ANTREAN,
  BPJS_WSBPJS_DASHBOARD_WAKTU_TUNGGU,
  BPJS_WSBPJS_REF_POLI_FINGERPRINT,
  BPJS_WSBPJS_REF_PASIEN_FINGERPRINT,
  BPJS_WSBPJS_TASKID,
  BPJS_VCLAIM_RUJUKAN_KHUSUS,
  BPJS_APOTEK,
  BPJS_VCLAIM_APPROVAL,
  BPJS_VCLAIM_SEP,
  UPLOAD_MANUAL_KRONIS,
  REKONSILIASI_KRONIS,
  BPJS_KONIFG_FR,
  BPJS_KONIFG_RK,
} from "App/constants";
import {
  BPJSApotek,
  BPJSVclaim,
  BPJSVclaimApprovalSep,
  BPJSVclaimPengajuanSep,
  BPJSVclaimPrb,
  BPJSVclaimSep,
  BPJSVclaimRujukan,
  BPJSVclaimRujukanKhusus,
  BPJSVclaimUpdateTanggalPulang,
  DaftarTagihanBPJS,
  InputEklaim,
  Purifikasi,
  Rekonsiliasi,
  RekonsiliasiBPJS,
  UploadManual,
  WSBPJS,
  WSBPJSAntrean,
  WSBPJSDasboardWaktuTunggu,
  WSBPJSRefPasienFingerPrint,
  WSBPJSRefPoliFingerPrint,
  WSBPJSTaskId,
  UploadManualKronis,
  RekonsiliasiKronis,
  KonfigurasiFileRekonsil,
  KonfigurasiRekonsil,
} from "../WrapperLazyExport";

export const menuBPJS = {
  [INPUT_EKLAIM]: <InputEklaim />,
  [BPJS_DAFTAR_TAGIHAN]: <DaftarTagihanBPJS />,
  [PURIFIKASI]: <Purifikasi />,
  [UPLOAD_MANUAL]: <UploadManual />,
  [REKONSILIASI]: <Rekonsiliasi />,
  [REKONSILIASI_BPJS]: <RekonsiliasiBPJS />,
  [BPJS_KONIFG_RK]: <KonfigurasiRekonsil />,
  [UPLOAD_MANUAL_KRONIS]: <UploadManualKronis />,
  [REKONSILIASI_KRONIS]: <RekonsiliasiKronis />,
  [BPJS_KONIFG_FR]: <KonfigurasiFileRekonsil />,
  // [ADMINISTRATIF_BPJS] : <AdministratifBPJS/>,

  //MENU VCLAIM
  [BPJS_VCLAIM_REFENSI]: <BPJSVclaim />,
  [BPJS_VCLAIM_PENGAJUAN]: <BPJSVclaimPengajuanSep />,
  [BPJS_VCLAIM_APPROVAL]: <BPJSVclaimApprovalSep />,
  [BPJS_VCLAIM_UPDATE_TGL_PLG]: <BPJSVclaimUpdateTanggalPulang />,
  [BPJS_VCLAIM_RUJUKAN]: <BPJSVclaimRujukan />,
  [BPJS_VCLAIM_RUJUKAN_KHUSUS]: <BPJSVclaimRujukanKhusus />,
  [BPJS_VCLAIM_PRB]: <BPJSVclaimPrb />,
  [BPJS_VCLAIM_SEP]: <BPJSVclaimSep />,

  //MENU WSBPJS
  [BPJS_WSBPJS_REFERENSI]: <WSBPJS />,
  [BPJS_WSBPJS_ANTREAN]: <WSBPJSAntrean />,
  [BPJS_WSBPJS_DASHBOARD_WAKTU_TUNGGU]: <WSBPJSDasboardWaktuTunggu />,
  [BPJS_WSBPJS_REF_POLI_FINGERPRINT]: <WSBPJSRefPoliFingerPrint />,
  [BPJS_WSBPJS_REF_PASIEN_FINGERPRINT]: <WSBPJSRefPasienFingerPrint />,
  [BPJS_WSBPJS_TASKID]: <WSBPJSTaskId />,

  //MENU APOTEK
  [BPJS_APOTEK]: <BPJSApotek />,
};
